import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kpis-bum',
  templateUrl: './kpis-bum.component.html',
  styleUrls: ['./kpis-bum.component.scss']
})
export class KpisBumComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
